import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';
import Promise from 'bluebird';
import ViewModel from '@bingads-webui-campaign-legacy/crud-campaign/viewmodel/copy-campaign-settings';
import template from '@bingads-webui-campaign-legacy/crud-campaign/template/copy-campaign-settings.pug';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import { getODataErrors } from '@bingads-webui-component-legacy/api-errors-campaign/index';
import * as criterionLoader from '@bingads-webui-campaign-legacy/base-targets/util/criterionLoader';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';
import CampaignSelectorProxy from '@bingads-webui-campaign-legacy/crud-campaign/view/campaign-selector-proxy';
import { DisclaimerAdExtension } from '@bingads-webui-campaign/campaign-ui-schemas';
import SharedRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repository';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default class View extends Backbone.View {
  initialize({
    scenario = 'copy-campaign-setttings',
    activityLogger,
  } = {}) {
    this.viewModel = new ViewModel({ scenario, activityLogger });
    this.scenario = scenario;
    this.activityLogger = activityLogger;
    this.campaignSelectorProxy = new CampaignSelectorProxy({
      onEventTrigger: (key, selectedItem) => {
        this.onCampaignSelectorEventTrigger(key, selectedItem);
      },
    });
    this.campaignSelector = this.campaignSelectorProxy.getCampaignSelectorView();
  }

  onCampaignSelectorEventTrigger(key, selectedItem) {
    if (_.isEqual(key, 'selected-campaign') && _.has(selectedItem, 'Id')) {
      this.loadCampaignAndTargets(selectedItem.Id);
    }
  }

  render() {
    this.$el.empty().append(template({ i18n }));
    this.$('.copy-settings').empty().append(this.campaignSelector.render().$el);
    ko.applyBindings(this.viewModel, this.el);

    return this;
  }

  loadCampaignAndTargets(id) {
    const params = {
      queryParameters: {
        entitySet: edmCampaign.currentAccount.Campaigns,
        expand: ['Budget'],
      },
      bypassCache: true,
    };

    const disclaimerRepository = new SharedRepository({
      schema: DisclaimerAdExtension,
      skipExtensionCache: true,
    });

    Promise.join(
      jsdata.Campaign.find(id, params),
      criterionLoader.load(id, '', ['LocationCriterion', 'RadiusCriterion', 'LocationIntentCriterion']),
      disclaimerRepository.association.findAll({
        where: {
          campaignId: id,
        },
      })
    ).then((result) => {
      this.trigger('copy.campaign', result);
      if (this.activityLogger) {
        this.activityLogger.signal('select campaign to copy campaign settings', this.scenario);
      }
    })
      .catch(({ errors }) => {
        this.trigger('copy.errors', getODataErrors(errors));
        if (this.activityLogger) {
          _.each(errors, (error) => {
            if (error && error.Code) {
              this.activityLogger.signal(`copy campaign settings error ${error.Code}`, this.scenario);
            }
          });
        }
      })
      .finally(withUiBlock());
  }

  hide() {
    this.viewModel.hide(true);
  }
}
